export default __webpack_public_path__ + "static/media/proposal-blue.058ce28d.svg";